import { render, staticRenderFns } from "./DeleteVideosModal.vue?vue&type=template&id=46be5976&"
import script from "./DeleteVideosModal.vue?vue&type=script&lang=js&"
export * from "./DeleteVideosModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteVideosModal.vue?vue&type=style&index=0&id=46be5976&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports